import { Fragment } from 'react';
import type { ChatNovelScript } from '~/app/_types/chat-script';
import type { StoryOverview } from '~/common/types/story-overview';
import { InReadAdContainer } from '@app/(default-layout)/s/[storyId]/_containers/in-read-ad-container';
import { VStack } from '@styled-system/jsx';
import { ChatSceneBackgroundContainer } from './chat-scene-background-container';
import { ChatScriptStateProvider } from './chat-script-state-provider';
import { OperationListRender } from './operation-list-render';
import { ReadEventContainer } from './read-event-container';

type Props = {
  story: StoryOverview;
  chatNovelScript: ChatNovelScript;
  canShowGoogleAd: boolean;
  nextStoryId?: string;
  nextStorySeriesIndex?: number;
  nextStoryIsVipOnly?: boolean;
};

export const ChatScriptRender = ({
  story,
  chatNovelScript,
  canShowGoogleAd,
  nextStoryId,
  nextStorySeriesIndex,
  nextStoryIsVipOnly,
}: Props) => {
  return (
    <ChatScriptStateProvider story={story} chatNovelScript={chatNovelScript}>
      <ReadEventContainer
        nextStoryId={nextStoryId}
        nextStorySeriesIndex={nextStorySeriesIndex}
        nextStoryIsVipOnly={nextStoryIsVipOnly}
      >
        <VStack alignItems="center" gap="0" w="full">
          {chatNovelScript.sceneList.map((scene, index) => {
            return (
              <Fragment key={`scene-${index}`}>
                <ChatSceneBackgroundContainer
                  key={`scene-${index}`}
                  scene={scene}
                  sceneIndex={index}
                  sceneCount={chatNovelScript.sceneList.length}
                >
                  <VStack
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    w="100%"
                    maxW="breakpoint-2xl"
                    px="5"
                    pt={index === 0 ? '24px' : '100px'}
                    pb="250px"
                    gap="100px"
                    animation="fadein 0.4s ease-out"
                    minHeight="103vh"
                  >
                    <OperationListRender ops={scene.ops} />
                  </VStack>
                </ChatSceneBackgroundContainer>
                {scene.opsCount > 10 &&
                  index < chatNovelScript.sceneList.length - 1 && (
                    <InReadAdContainer
                      canShowGoogleAd={canShowGoogleAd}
                      adIndex={index}
                      bg="strong_bg"
                    />
                  )}
              </Fragment>
            );
          })}
        </VStack>
      </ReadEventContainer>
    </ChatScriptStateProvider>
  );
};
